<template>
  <div class="tab_con modelContent_">
    <div class="tab_" v-if="content" v-html="content"></div>
  </div>
</template>

<script>
import api from "@/utils/sdApi";
export default {
  data() {
    return {
      id: "",
      content: "",
    };
  },
  mounted() {
    this.queryQuotationInfo();
  },
  methods: {
    queryQuotationInfo() {
      let data = {
        quoteId: this.$route.query.qid,
        type: 'Q'
      };
      this.id = this.$route.query.id;
      console.log(this.$route.query.id);
      api.queryQuotationInfo(data).then((res) => {
        let array = res.data.msg.labelContents;
        console.log(array);
        let exit = array.find((item) => {
          return this.id == item.id;
        });
        if (exit) {
          this.content = exit.modelContent;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_con {
  width: 92%;
  margin: 0 auto;
  padding: 10px 0;
}
</style>